import create from "zustand";

export type ModalStore = {
  modalVisibleMap: Map<string, boolean>;
  recruiterEnable?: boolean;
  isLoadingModal: boolean;

  openModal: (outcomeId: string, shouldOpen?: boolean) => void;
  closeModal: (outcomeId: string) => void;
  isModalOpen: (outcomeId: string) => boolean;
  beforeCompletePredicate: (outcomeId: string) => Promise<boolean>;
  setIsLoadingModal: (value: boolean) => void;
};

export const createModalStore = () =>
  create<ModalStore>((set, get) => ({
    modalVisibleMap: new Map(),
    recruiterEnable: false,
    isLoadingModal: false,

    openModal: (outcomeId, shouldOpen = true) =>
      set((state) => {
        const newMap = new Map(state.modalVisibleMap);
        newMap.set(outcomeId, shouldOpen);
        return { modalVisibleMap: newMap };
      }),

    closeModal: (outcomeId) =>
      set((state) => {
        const newMap = new Map(state.modalVisibleMap);
        newMap.delete(outcomeId);
        return { modalVisibleMap: newMap };
      }),

    isModalOpen: (outcomeId) => get().modalVisibleMap.get(outcomeId) ?? false,

    beforeCompletePredicate: async (_outcomeId: string) => {
      console.log("beforeCompletePredicate");
      return true;
    },

    setIsLoadingModal: (value) => set({ isLoadingModal: value }),
  }));
